import React from 'react';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
export var FieldDescription = function (_a) {
    var _b = _a.expanded, expanded = _b === void 0 ? false : _b, children = _a.children;
    return (React.createElement(Collapse, { in: expanded },
        React.createElement(Box, { pt: 1 },
            React.createElement(Typography, { variant: 'hint' }, children))));
};
export default FieldDescription;
